import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { UpsertPartnerTransactionSchemaInput, UpsertPartnerTransactionSchemaPayload } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_UPSERT_PARTNER_TRANSACTION_SCHEMA = gql`
    mutation upsertPartnerTransactionSchema($input: UpsertPartnerTransactionSchemaInput!){
        upsertPartnerTransactionSchema(input: $input){
            message
            errors {
                code
                message
            }
            result
            transactionSchemaId
        }
    }
`;

export const mutationUpsertTradingPartnerTransactionSchema = async (
    client: ApolloClient<NormalizedCacheObject>, args: {
        schemaInputData: UpsertPartnerTransactionSchemaInput
    }
): Promise<UpsertPartnerTransactionSchemaPayload | undefined> => {
    const { description, documentString, id, partnerTransactionId, sourceFileName, standardVersion } = args.schemaInputData;
    const { data, errors } = await client.mutate<{ upsertPartnerTransactionSchema: UpsertPartnerTransactionSchemaPayload }>({
        variables: {
            input: {
                description,
                documentString,
                id,
                partnerTransactionId,
                sourceFileName,
                standardVersion
            }
        },
        mutation: MUTATION_UPSERT_PARTNER_TRANSACTION_SCHEMA
    });
    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console
            console.error(error);
        });
        // Friendly error to active user
        throw new Error('An error has occurred during the save of Partner Transaction EDI Rules Schema.');
    }
    if (data && data.upsertPartnerTransactionSchema) {
        return data.upsertPartnerTransactionSchema;
    }

    return undefined;
}